import { forwardRef, useId } from "react";
import { RadioProps } from "./Radio.types";
import { twMerge } from "tailwind-merge";
import { Theme } from "./Radio.theme";

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio({
  containerClassname,
  className,
  label,
  value,
  disabled,
  ...props
}: RadioProps, ref) {

  const id = useId();

  return (
    <div className={twMerge("flex items-center mb-2", disabled && "pointer-events-none opacity-60", containerClassname)}>
      <input
        ref={ref}
        className={twMerge(Theme.input, className)}
        value={value?.toString()}
        type="radio"
        id={id}
        aria-disabled={disabled || undefined}
        {...props}
      />
      {(!!label) && (
        <label htmlFor={id} className={twMerge(Theme.label, disabled && Theme.labelDisabled)}>
          {label}
        </label>
      )}
    </div>
  );
});
